import { LiteralUnion } from "antd/lib/_util/type";
import RateioRelatorioCentroCusto, { RateioRelatorioCentroCustoValor } from "../../../../../Models/Financeiro/Titulo/Rateio/RateioRelatorioCentroCusto";
import { Card, Col, Row, Tag } from 'antd';
import TituloSituacao, { EnumTituloSituacao } from "../../../../../Models/Financeiro/Titulo/TituloSituacao";
import Utilitario from "../../../../../Utils/Utilitario";
import Empty from "antd/lib/empty";
interface IRateioRelatorioSituacaoTagsBasicProps {
    data: RateioRelatorioCentroCusto
}
type ColorTituloSituacao = "processing" | "success" | "error" | "default" | "warning";
export default function RateioRelatorioSituacaoTagsBasic({
    data
}: IRateioRelatorioSituacaoTagsBasicProps) {
    function situacaoParaColorTag(situacao: TituloSituacao): ColorTituloSituacao {
        switch (situacao.codigo) {
            case EnumTituloSituacao.Pendente:
                return "processing";
            case EnumTituloSituacao.Liquidado:
                return "success";
            case EnumTituloSituacao.Cancelado:
                return "error";
            default:
                return "warning";
        }
    }
    function renderItem(valor: RateioRelatorioCentroCustoValor, index: number, listAll: RateioRelatorioCentroCustoValor[]) {
        return <Tag color={situacaoParaColorTag(valor.situacao)} key={index}>
            {valor.situacao.nome} {Utilitario.toStringDinheiro(valor.situacao.codigo == EnumTituloSituacao.Liquidado ? valor.valorRecebido : valor.valorPrevisto)}
        </Tag>;
    }

    return <Row gutter={[12, 12]}>
        <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <Card
                hoverable
                style={{ width: "100%", height: "100%" }}
            >
                <Card.Meta 
                    title={`Receita - Total: ${Utilitario.toStringDinheiro(data.receitaTotal)}`} 
                    description={
                        (data?.valoresResumido ?? []).filter(f => f.entrada).length <= 0 
                            ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Nunhuma receita encontrada!" />
                            : <span>{(data?.valoresResumido ?? []).filter(f => f.entrada).sort((a1, b1) => a1.situacao.codigo - b1.situacao.codigo).map(renderItem)}</span>} 
                    />
            </Card>
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <Card
                hoverable
                style={{ width: "100%", height: "100%" }}
            >
                <Card.Meta 
                    title={`Despesa - Total: ${Utilitario.toStringDinheiro(data.despesaTotal)}`} 
                    description={
                        (data?.valoresResumido ?? []).filter(f => !f.entrada).length <= 0 
                            ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Nunhuma despesa encontrada!" /> 
                            : <span>{(data?.valoresResumido ?? []).filter(f => !f.entrada).sort((a1, b1) => a1.situacao.codigo - b1.situacao.codigo).map(renderItem)}</span>} 
                />
            </Card>
        </Col>
    </Row>;
}